import { useSite } from "@/lib/SiteContext";
import { useT } from "@/lib/i18n";
import Reveal from "./Reveal";

export const Manifesto = () => {
  const { locale } = useSite();
  const { t } = useT(locale);

  return (
    <section
      className="relative py-28 md:py-40"
      style={{ backgroundColor: "var(--ix-cream)", color: "var(--ix-night)" }}
      data-testid="manifesto-section"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 relative">
          <div className="lg:col-span-3">
            <Reveal>
              <div className="ix-mono text-[0.7rem] uppercase tracking-[0.18em] flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: "linear-gradient(135deg,#FF1F8F,#8AE52E)" }} />
                {t("manifesto.eyebrow")}
              </div>
              <div className="mt-6 ix-rule-grad" />
              <div
                aria-hidden
                className="mt-10 hidden lg:block"
                style={{
                  width: "120px", height: "160px",
                  background: "linear-gradient(135deg, #FF1F8F 0%, #FCB424 100%)",
                  clipPath: "polygon(22% 0%, 100% 0%, 78% 100%, 0% 100%)",
                  opacity: 0.95,
                }}
              />
              <div className="mt-8 ix-mono text-[0.7rem] uppercase tracking-[0.18em] text-[var(--ix-night)]/55 max-w-[180px] leading-relaxed">
                "Donde otros venden destinos, nosotros activamos territorios."
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-9">
            <Reveal delay={120}>
              <h2 className="ix-display ix-headline-lg">
                {t("manifesto.lead").split(" ").map((w, i, arr) => {
                  const isLast = i === arr.length - 1;
                  const stripped = w.replace(/[.,;:]/g, "");
                  const highlight = ["genéricos.", "genéricos", "generic.", "generic"].includes(w) || stripped === "genéricos" || stripped === "generic";
                  return (
                    <span key={i}>
                      {highlight ? <span className="ix-grad-text" style={{ fontWeight: 700 }}>{w}</span> : w}
                      {!isLast ? " " : ""}
                    </span>
                  );
                })}
              </h2>
            </Reveal>

            <Reveal delay={260}>
              <p className="mt-12 text-[1.1rem] md:text-[1.25rem] leading-[1.5] text-[var(--ix-night)]/85 max-w-3xl">
                {t("manifesto.paragraph_1")}
              </p>
            </Reveal>

            <Reveal delay={360}>
              <p className="mt-7 text-[0.98rem] md:text-[1.05rem] leading-relaxed text-[var(--ix-muted)] max-w-3xl">
                {t("manifesto.paragraph_2")}
              </p>
            </Reveal>

            <Reveal delay={460}>
              <div className="mt-14 grid grid-cols-3 gap-4 md:gap-6 max-w-2xl">
                {[
                  { k: locale === "es" ? "Diseñamos" : "We design", v: locale === "es" ? "Contigo" : "With you" },
                  { k: locale === "es" ? "Territorio" : "Territory", v: locale === "es" ? "Conocido" : "Known" },
                  { k: locale === "es" ? "Visión" : "Vision", v: locale === "es" ? "Estratégica" : "Strategic" },
                ].map((p) => (
                  <div key={p.k} className="border-l border-[var(--ix-night)]/15 pl-4">
                    <div className="ix-mono text-[0.6rem] uppercase tracking-[0.2em] text-[var(--ix-night)]/55">{p.k}</div>
                    <div className="ix-display text-lg md:text-xl mt-1 text-[var(--ix-night)]">{p.v}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
